import { render, staticRenderFns } from "./ListCotizaciones.vue?vue&type=template&id=c270f928&"
import script from "./ListCotizaciones.vue?vue&type=script&lang=js&"
export * from "./ListCotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports